import { lang } from '@ott/l10n';
import currency from './currency';

const [language, locale] = (lang || '').split('-');

const getMainLocaleParams = () => ({
  lang: language || 'ru',
  locale: locale || language || 'ru',
  currency: currency || 'RUB',
});

export default getMainLocaleParams;
